import { userServiceClient } from '@/services/api';
import {
    PublicProfile,
    PublicProfileSchema,
    UserProfile,
    UserProfileSchema,
} from '@/types/UserProfile';

export default class UserService {
    static federatedLogin(provider: string, token: string) {
        return userServiceClient.post('/user/federated-login', { provider, token });
    }

    static signUp(password: string, email?: string, phone_number?: string) {
        const payload: { email?: string; phoneNumber?: string; password: string } = { password };

        if (email) {
            payload.email = email;
        } else if (phone_number) {
            payload.phoneNumber = phone_number;
        }

        return userServiceClient.post('/user/signup', payload);
    }

    static login(username: string, password: string) {
        return userServiceClient.post('/user/login', { username, password });
    }

    static confirmLogin(user_id: string, confirmation_code: string) {
        return userServiceClient.post('/user/confirm', { user_id, confirmation_code });
    }

    static forgotPassword(contact: string) {
        return userServiceClient.post('/user/forgot-password', {
            contact,
        });
    }

    static resetPassword(email?: string, phone_number?: string) {
        const payload: { email?: string; phoneNumber?: string } = {};

        if (email) {
            payload.email = email;
        } else if (phone_number) {
            payload.phoneNumber = phone_number;
        }

        return userServiceClient.post('/user/reset-password', payload);
    }

    static confirmResetPassword(user_id: string, confirmation_code: string, new_password: string) {
        return userServiceClient.post('/user/confirm-reset-password', {
            user_id,
            confirmation_code,
            new_password,
        });
    }

    static setProfileDirect(user_id: string, profile: any) {
        return userServiceClient.post('/user/set-profile-direct', {
            user_id,
            profile,
        });
    }

    static getSignedUrlsForProfile(image_type: string) {
        return userServiceClient.get('/user/get-signed-urls-for-profile', {
            params: {
                image_type: image_type,
            },
        });
    }

    static get_admin_profile(user_id: string) {
        return userServiceClient.get('/user/get-admin-profile', {
            params: {
                id: user_id,
            },
        });
    }

    static set_admin_profile(user_id: string, auth: object) {
        return userServiceClient.post('/user/set-admin-profile', {
            id: user_id,
            auth: auth,
        });
    }

    static async profile(user_id: string, public_profile: boolean): Promise<UserProfile | null> {
        const resp = await userServiceClient.get('/user/get-profile', {
            params: {
                id: user_id,
                public: public_profile,
            },
        });
        if (!resp || !resp.data) {
            return null;
        }
        return UserProfileSchema.parse(resp.data);
    }

    static async getPublicProfile(user_id: string): Promise<PublicProfile | null> {
        if (!user_id) {
            return null;
        }
        const resp = await userServiceClient.get('/user/get-public-profile', {
            params: {
                id: user_id,
            },
        });
        console.trace('getPublicProfile', resp);
        console.log('id', user_id);
        if (!resp || !resp.data) {
            return null;
        }

        return PublicProfileSchema.parse(resp.data);
    }

    static async getPublicProfiles(user_ids: string[]): Promise<PublicProfile[]> {
        const resp = await userServiceClient.get('/user/get-public-profiles', {
            params: {
                user_ids: user_ids.join(','),
            },
        });
        if (!resp || !Array.isArray(resp.data.profiles)) return [];

        return resp.data.profiles.map((profileData: unknown) =>
            PublicProfileSchema.parse(profileData)
        );
    }

    static refreshToken(refresh_token: string, duration = 60) {
        return userServiceClient.post('/user/refresh-tokens', {
            RefreshToken: refresh_token,
            Duration: duration,
        });
    }

    static getActiveUsers() {
        return userServiceClient.get('/user/get-active-users');
    }

    static getTotalUsers() {
        return userServiceClient.get('/user/get-total-users');
    }
}
